import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { PageHeading, PageHeadingDescription, PageHeadingTitle } from '@/components/ui/page-heading';
import type { PersonalInformation, PersonalInformationTaxResidency } from '@/features/onboarding/personal-information/schema';
import { TaxResidencyFieldset } from '@/features/tax-residency/components/fieldset';
import { reportTaxResidenceFormatErrors } from '@/features/tax-residency/report';
import type { FormStepGuard } from '@/hooks/use-form-step-guard';

export const PersonalInformationFormFieldsetTaxResidencyLegend = () => {
  const { t } = useTranslation();

  return (
    <PageHeading asChild>
      <legend>
        <PageHeadingTitle>{t('personalInformation.taxResidencyTitle')}</PageHeadingTitle>
        <PageHeadingDescription>{t('personalInformation.taxResidencyDescription')}</PageHeadingDescription>
      </legend>
    </PageHeading>
  );
};
PersonalInformationFormFieldsetTaxResidencyLegend.displayName = 'PersonalInformationFormFieldsetTaxResidencyLegend';

export const PersonalInformationFormFieldsetTaxResidency = () => {
  const form = useFormContext<PersonalInformationTaxResidency & Pick<PersonalInformation, 'taxId'>>();
  const { t } = useTranslation();
  const previousTaxId = form.watch('taxId');

  return (
    <div className="space-y-6">
      <TaxResidencyFieldset<PersonalInformationTaxResidency> name="taxResidences" previousTaxId={previousTaxId} />
      <p className="text-sm">{t('personalInformation.taxResidencyDeclaration')}</p>
    </div>
  );
};
PersonalInformationFormFieldsetTaxResidency.displayName = 'PersonalInformationFormFieldsetTaxResidency';

// The stepper's own validation has no failure callback, so a rejected TIN is reported as the step is left
const beforeStepLeave: FormStepGuard<PersonalInformation> = async ({ direction, form }, next) => {
  if (direction === 'next') await reportTaxResidenceFormatErrors(form.getValues('taxResidences'));

  return next();
};

PersonalInformationFormFieldsetTaxResidency.beforeStepLeave = beforeStepLeave;
